export default [
  {
    path: "/globals",
    name: "globals",
    redirect: { name: 404 },
    component: () => import("./moduleLayout.vue"),
    children: [
      {
        path: "/shaml-form",
        name: "shaml-form",
        component: () => import("./pages/shaml-form/index.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
      {
        path: "/shaml-form/form-submitted",
        name: "shaml-form-submitted",
        component: () => import("./pages/shaml-form/FomrSubmitted.vue"),
        meta: {
          layout: "full",
          whiteListed: true,
        },
      },
    ],
  },
];
